export default class WineType {
	constructor() {
		this.id = null;
		this.title = null;
		this.localeKey = null;
		this.grapeVarieties = [];
	}
}